import { createSlice } from "@reduxjs/toolkit";
import getMeristemDefaultValue from "../../meristemContext/meristemContextDefaults";

const extractData = (data) => {
  return {
    city_name: data.city_name,
    continent_code: data.continent_code,
    country_code: data.country_code,
    is_eu_citizen: data.is_eu_citizen,
    postal_code: data.postal_code,
    subdivision: data.subdivision,
    is_forced_country_code: data.is_forced_country_code,
  };
};

const geoLocationSlice = createSlice({
  name: "geoLocation",
  initialState: extractData(getMeristemDefaultValue()),
  reducers: {
    setGeoLocation(state, action) {
      return extractData(action.payload) || state;
    },
  },
});

export const { setGeoLocation } = geoLocationSlice.actions;

export default geoLocationSlice.reducer;
